// extracted by mini-css-extract-plugin
export default {"ad":"ad__djWxf"};